import styled from "styled-components";

export const Container = styled.div`
  padding: 1.5rem;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
`;

export const QuestionnaireHeader = styled.div`
  display: flex;
	flex-direction: column;
  gap: 0.5rem;
`;

export const QuestionnaireTitle = styled.h3`
  margin: 0;
  color: #333;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.4;
`;

export const QuestionnaireDescription = styled.p`
  margin: 0;
  color: #6c757d;
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 1.4;
`;

export const QuestionnairePassingScore = styled.p`
  margin: 0;
  color: #333;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.4;
`;

export const QuestionItem = styled.div`
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const QuestionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 0.5rem;
`;

export const QuestionTitle = styled.h4`
  margin: 0;
  color: #333;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.4;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  gap: 1rem;
  flex: 1;
`;

export const ScoreWeight = styled.span`
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
  width: 80px;
  text-align: center;
`;

export const OptionsList = styled.ul`
  margin: 0.5rem 0 0 0;
  padding: 0;
  list-style: none;
`;

export const OptionItem = styled.li`
  margin-bottom: 0.5rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const CorrectOption = styled.div`
  padding: 0.5rem 0.75rem;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  color: #155724;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  
  &::before {
    content: "✓";
    font-weight: bold;
    color: #28a745;
  }
`;

export const OptionScore = styled.span`
  background-color: #f8f9fa;
  color: #495057;
  padding: 0.2rem 0.4rem;
  border-radius: 3px;
  font-size: 0.75rem;
  font-weight: 500;
  border: 1px solid #dee2e6;
  width: 80px;
  text-align: center;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const IncorrectOption = styled.div`
  padding: 0.5rem 0.75rem;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  
  &::before {
    content: "○";
    font-weight: bold;
    color: #adb5bd;
  }
`;

